export { DiningDetail } from './DiningDetail';
